import React, { useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import LoadingSpinner from '../../../../../components/Spinner';

import TXTRecord from './TXTRecord';

const DomainRecords = ({ companyDomain }) => {
  const records = useMemo(() => {
    if (companyDomain) {
      const { outboundDnsRecords: { spf }, outboundDnsRecords: { dkim } } = companyDomain;

      return ([
        {
          title: 'SPF',
          name: spf.name,
          status: spf.valid,
          value: spf.value
        },
        {
          title: 'DKIM',
          name: dkim.name,
          status: dkim.valid,
          value: dkim.value
        }
      ]);
    }

    return [];
  }, [companyDomain]);

  if (!companyDomain) {
    return (
      <Box borderBottom="1px solid" borderBottomColor="greyScale.200" p={8}>
        <LoadingSpinner isInline maxHeight="200px" />
      </Box>
    );
  }

  return (
    <>
      {records.map(record => (
        <TXTRecord
          key={record.title}
          name={record.name}
          status={record.status}
          title={record.title}
          value={record.value}
        />
      ))}
    </>
  );
};

DomainRecords.propTypes = {
  companyDomain: PropTypes.shape({
    outboundDnsRecords: PropTypes.shape({
      spf: PropTypes.shape({
        name: PropTypes.string,
        valid: PropTypes.string,
        value: PropTypes.string
      }),
      dkim: PropTypes.shape({
        name: PropTypes.string,
        valid: PropTypes.string,
        value: PropTypes.string
      })
    })
  })
};

export default DomainRecords;
